import { render, staticRenderFns } from "./ModalValidation.vue?vue&type=template&id=bc31d89c&scoped=true&"
import script from "./ModalValidation.vue?vue&type=script&lang=js&"
export * from "./ModalValidation.vue?vue&type=script&lang=js&"
import style0 from "./ModalValidation.vue?vue&type=style&index=0&id=bc31d89c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc31d89c",
  null
  
)

export default component.exports